import { GenericValue } from 'hisng';
import { Component } from '@angular/core';
import { WithDatasourceComponent } from './with-datasource.component';

@Component( {
    selector: 'erp-pbw-adt-bez',
    templateUrl: './with-datasource.component.html'
} )
export class OfficialDesignationFormComponent extends WithDatasourceComponent<GenericValue> {

    constructor() {
        super(
            {
                datasourceName: 'api/v1/rm/erp/person/value/officialdesignation',
                fieldDisplayName: 'text',
                i18nIdentifier: 'rm.erp.jobapplication.JobApplication.officialDesignation',
            } );
    }

    set value( t: GenericValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.officialDesignation = t;
        }
    }

    get value(): GenericValue | undefined {
        return this.jobapplication?.officialDesignation;
    }

    getFieldValue( t?: GenericValue ): string | undefined {
        return t?.text;
    }
}
